import React, { useState } from "react";
import { useLanguage } from "../../Contexts/LanguageContext";

const ContactSection = () => {
    const { language } = useLanguage();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.message) {
            setError(
                language === "English"
                    ? "Please fill in all fields."
                    : "Por favor, completa todos los campos."
            );
            return;
        }

        try {
            const res = await fetch("/send", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (res.ok) {
                setSubmitted(true);
                setError("");
                setFormData({ name: "", email: "", message: "" });
            } else {
                throw new Error("Email failed");
            }
        } catch (err) {
            setError(
                language === "English"
                    ? "Something went wrong. Please try again later."
                    : "Algo salió mal. Por favor, inténtalo de nuevo más tarde."
            );
        }
    };

    return (
        <section className="w-full py-16 px-4 bg-gradient-to-b from-[#c2b7f5] via-[#a0b9ff] to-[#f6f6ff]">
            <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-3xl font-bold text-gray-700 mb-6">
                    {language === "English" ? "Contact Me" : "Contáctame"}
                </h2>
                <p className="text-gray-600 mb-10">
                    {language === "English"
                        ? "I'd love to hear from you! Fill out the form below and I’ll be in touch."
                        : "¡Me encantaría saber de ti! Completa el siguiente formulario y me pondré en contacto contigo."}
                </p>

                {submitted && (
                    <div className="mb-6 text-green-600 font-medium">
                        {language === "English"
                            ? "Thank you! Your message has been sent."
                            : "¡Gracias! Tu mensaje ha sido enviado."}
                    </div>
                )}

                {error && (
                    <div className="mb-4 text-red-500 font-medium">{error}</div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <input
                            type="text"
                            name="name"
                            placeholder={
                                language === "English"
                                    ? "Your Name"
                                    : "Tu Nombre"
                            }
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        />
                    </div>
                    <div>
                        <input
                            type="email"
                            name="email"
                            placeholder={
                                language === "English"
                                    ? "Your Email"
                                    : "Tu Correo"
                            }
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        />
                    </div>
                    <div>
                        <textarea
                            name="message"
                            placeholder={
                                language === "English"
                                    ? "Your Message"
                                    : "Tu Mensaje"
                            }
                            rows="5"
                            value={formData.message}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 resize-none"
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition duration-300 shadow"
                    >
                        {language === "English"
                            ? "Send Message"
                            : "Enviar Mensaje"}
                    </button>
                </form>
            </div>
        </section>
    );
};

export default ContactSection;
